var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuleboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#c2c2c2",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,18H7.382L6.105,20.553a1,1,0,0,0,1.79.894L9.618,18H11v2a1,1,0,0,0,2,0V18h1.382l1.723,3.447a1,1,0,1,0,1.79-.894L16.618,18H21a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H13V3a1,1,0,0,0-2,0V4H3A1,1,0,0,0,2,5V17A1,1,0,0,0,3,18ZM4,6H20V16H4Zm5,5v2a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0Zm4-1v3a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Zm4-1v4a1,1,0,0,1-2,0V9a1,1,0,0,1,2,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleboard);
export default __webpack_public_path__ + "static/media/ruleboard.fa658360b96d99998c88e000afb10c4e.svg";
export { ForwardRef as ReactComponent };